import React, { useState } from 'react'

import { useProcesses } from '../../../providers/ProcessesContext';
import { useAuth } from '../../../providers/AuthContext';
import { useNavigate } from 'react-router-dom';

import ArrowDown from '../../../components/icons/ArrowDown';
import ArrowUp from '../../../components/icons/ArrowUp';
import DashboardIco from '../../../components/icons/DashboardIco';
import ListIco from '../../../components/icons/ListIco';
import SettingsIco from '../../../components/icons/SettingsIco';
import AddCircle from '../../../components/icons/AddCircle';
import { createProcess } from '../../../services/apiProcess';



function Menu() {
  const navigate = useNavigate();
  const { 
    selectedOption, 
    setSelectedOption, 
    selectedSubOption, 
    setSelectedSubOption,
    menuItems,
    refreshMenu
  } = useProcesses();
  const {auth, hasPermission} = useAuth();

  const [isOpen, setIsOpen] = useState({});
  const [creatingProcess, setCreatingProcess] = useState(false);

  const toggleMenu = (index) => {
    setIsOpen((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  const handleMainOptionClick = (label, index) => {
    toggleMenu(index);
    console.log(menuItems)
    if (index === 0) setSelectedOption(label) ;
    //setSelectedSubOption(null);  // Clear selected suboption when changing main option
  };

  const handleSubOptionClick = (mainOption, subOption) => {
    setSelectedOption(mainOption);
    setSelectedSubOption(subOption);
  };

  const handleCreateProcess = () => {
    async function createProcesses() {
      setCreatingProcess(true)
      const process = await createProcess(
        {
          name: "Nuevo Proceso"
        },auth?.token);
      //setOrganizations(organizationsData);
      return process;
    }
    try {
      createProcesses().then(response => {
        
        refreshMenu();
        setSelectedOption(response._id);
        setSelectedSubOption("Configuración")
        setCreatingProcess(false);
        toggleMenu(menuItems.length);
      }).catch(error => 
        navigate('/logout')
      );
    } catch (error) {
      setCreatingProcess(false)
      console.log(error)
    }
  }

  return (
    <div className="w-full h-full bg-white flex flex-col shadow-md justify-between overflow-y-auto border-r-2">
      <div>
        {menuItems.map((item) => (
          <div key={item.index}  >
            <button
              className={` w-full text-left py-2 px-4 focus:outline-none ${selectedOption === item.id ? 'bg-bluesens text-white ' : 'border-y-2'}`}
              onClick={() => handleMainOptionClick(item.id, item.index)}
            >
              <div className='flex justify-between'>
                <div className='flex items-center gap-1'>
                  {item.label === "Dashboard" && (
                    <DashboardIco height="20px" width="20px" fill={`${selectedOption === item.id ? 'white ' : ''}`}/>
                  )}
                  <span>{item.label}</span>
                </div>
                
                {item.hasSubItems && isOpen[item.index] && (
                  <ArrowUp />
                )}
                {item.hasSubItems && !isOpen[item.index] && (
                  <ArrowDown />
                )}
              </div>
              
            </button>
            {item.hasSubItems && isOpen[item.index] && (
              <div
                className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen[item.index] ? 'max-h-screen pl-4' : 'max-h-0'}`}//""
                style={{ maxHeight: isOpen[item.index] ? 'max-content' : 0 }}
              >
                {item.subItems.map((subItem, subIndex) => (
                  <button
                    key={subIndex}
                    className={`w-full items-center text-left py-1.5 px-2 hover:underline hover:text-gray-700 focus:outline-none ${selectedSubOption === subItem && selectedOption === item.id ? 'text-blue-500' : 'text-black'}`}
                    onClick={() => handleSubOptionClick(item.id, subItem)}
                  >
                    <div className='flex  gap-1 '>
                      {subItem === "Registros" &&(
                        <ListIco height="20px" width="20px" fill={`${selectedSubOption === subItem && selectedOption === item.id ? '#3b82f6 ' : 'black'}`}/>
                      )}
                      {subItem === "Configuración" && (
                        <SettingsIco height="20px" width="20px" fill={`${selectedSubOption === subItem && selectedOption === item.id ? '#3b82f6 ' : 'black'}`}/>
                      )}
                      {subItem}
                    </div>
                  </button>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
      <div className="py-1 px-4 border-y-2">
        {hasPermission("Process", "Process", "CREATE") && (
          <>
            { creatingProcess && (
              <div className='flex gap-2 justify-center w-full h-10 items-center'>
                <div role="status" >
                  <svg aria-hidden="true" className="inline w-8 h-8 text-gray-200 animate-spin  fill-bluesens" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                      <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                  </svg> 
                </div>
                <span className='text-sm text-gray-400'>Creando...</span>
              </div>
            )}
            {!creatingProcess && (
              <button className='flex gap-2 justify-center mx-auto items-center' onClick={ () => handleCreateProcess()}>
                <AddCircle height='40px' width="35px" fill='bluesens' />
                <span >Nuevo Proceso</span>
              </button>
            )}
          </>
        )}
        
          
          
          
        
      </div>
    </div>
  )
}

export default Menu